import {
    CSSProperties,
    ChangeEventHandler,
    KeyboardEventHandler,
    RefObject,
    useContext,
    useRef,
    ReactNode,
} from "react";
import { emailLogo, phoneLogo, calenderIcon } from "../../../../assets/assetsSVG";
import QuestContext from "../../../../components/QuestWrapper";

import "./css/InputModule.css";

const LogoType = {
    email: emailLogo,
    phone: phoneLogo,
    text: () => <></>,
    number: phoneLogo,
    date: calenderIcon,
};

export type logoType = keyof typeof LogoType;

interface PropType {
    placeholder?: string;
    type?: keyof typeof LogoType;
    style?: CSSProperties | undefined;
    onChange?: ChangeEventHandler<HTMLInputElement> | undefined;
    onKeyUp?: KeyboardEventHandler<HTMLInputElement> | undefined;
    onKeyDown?: KeyboardEventHandler<HTMLInputElement> | undefined;
    iconColor?: string;
    value?: string;
    logoPosition?: "left" | "right" | "both";
    ref?: RefObject<HTMLInputElement>;
    dateErrorStyle?: CSSProperties | undefined;
    datetext?: string;
    required?: boolean;
    regexKey?: string | undefined,
    regexMessage?: string,
    name?: string;
    preventFutureSelection?: boolean;
    preventPastSelection?: boolean;
    children?: ReactNode;
    className?: string;
    key?: string | number | undefined;
    minDate?: string;
    maxDate?: string;
}

export const DateInputModule = ({
    placeholder,
    type,
    onChange,
    iconColor,
    value,
    onKeyUp,
    onKeyDown,
    ref,
    logoPosition = "right",
    dateErrorStyle,
    datetext,
    required,
    regexKey,
    regexMessage,
    name,
    preventFutureSelection,
    preventPastSelection,
    key,
    style,
    minDate = "",
    maxDate = ""
}: PropType) => {
    const { themeConfig } = useContext(QuestContext.Context);

    const dateRef = useRef<HTMLInputElement>(null);

    const convertDateFormat = (dateStr: string) => {
        const parts = dateStr.split('-');
        return `${parts[2]}-${parts[1]}-${parts[0]}`;
    }

    let minDateConverted;
    let maxDateConverted;

    if (minDate || preventPastSelection) {
        let pastLastDate = new Date().toISOString().split('T')[0];
        minDateConverted = minDate ? convertDateFormat(minDate) : pastLastDate;
    }
    if (maxDate || preventFutureSelection) {
        let futureLastDate = new Date(new Date().setDate(new Date().getDate())).toISOString().split('T')[0];
        maxDateConverted = maxDate ? convertDateFormat(maxDate) : futureLastDate;
    }

    return (
        <>
            <div
                className="q_input_cont"
                onClick={() => dateRef.current?.showPicker()}
                style={{
                    ...style,
                }}
            >
                <label
                    htmlFor="dateInput"
                    className="q_input_custom_datePicker_label"
                >
                    <input
                        type={"date"}
                        name="dateInput"
                        placeholder={placeholder}
                        className="q_input_main_cont q_input_custom_datePicker"
                        onChange={onChange}
                        value={value}
                        required={required}
                        ref={dateRef}
                        // max={preventFutureSelection ? new Date(new Date().setDate(new Date().getDate() - 1)).toISOString().split('T')[0] : undefined}
                        // min={preventPastSelection ? new Date().toISOString().split('T')[0] : undefined}
                        min={minDateConverted ? minDateConverted : undefined}
                        max={maxDateConverted ? maxDateConverted : undefined}
                        key={key}
                    />
                    {value ? (
                        <div
                            style={{
                                display: "inline",
                                marginTop: "2px",
                                color: style?.color,
                                fontSize: style?.fontSize,
                            }}
                        >
                            {value}
                        </div>
                    ) : (
                        <div
                            style={{
                                display: "inline",
                                color: "#8E8E8E",
                                marginTop: "2px",
                                fontSize: style?.fontSize,
                            }}
                        >
                            {placeholder}
                        </div>
                    )}
                </label>
                {LogoType["date"](iconColor || "#B9B9B9")}
            </div>
        </>
    );
};
